import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { LOGO_URL, SITE_URL } from "@/lib/constants";
import { Download, Send } from "lucide-react";
import { toast } from "sonner";

const TYPE_LABELS = { adherent: "Adhérent", sympathisant: "Sympathisant", benevole: "Bénévole" };

export const MemberCard = ({ membership, name, onSendCard, sending }) => {
  const qrRef = useRef(null);
  const number = membership?.member_number || "—";
  const qrValue = membership?.member_number ? `${SITE_URL}/verifier/${membership.member_number}` : "—";
  const fullName = membership?.full_name || name || "Membre DEFAR";
  const type = TYPE_LABELS[membership?.membership_type] || "Membre";

  const buildDataUrl = () => {
    try {
      const W = 760, H = 460;
      const canvas = document.createElement("canvas");
      canvas.width = W; canvas.height = H;
      const ctx = canvas.getContext("2d");
      const grad = ctx.createLinearGradient(0, 0, W, H);
      grad.addColorStop(0, "#0F3B68");
      grad.addColorStop(1, "#064E3B");
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, W, H);

      ctx.fillStyle = "#ffffff";
      ctx.font = "bold 30px Arial";
      ctx.fillText("DEFAR - Les Bâtisseurs", 40, 70);
      ctx.font = "16px Arial";
      ctx.fillStyle = "#A7F3D0";
      ctx.fillText("CARTE DE MEMBRE OFFICIELLE", 40, 100);

      ctx.fillStyle = "#A7F3D0";
      ctx.font = "14px Arial";
      ctx.fillText("MEMBRE", 40, 220);
      ctx.fillStyle = "#ffffff";
      ctx.font = "bold 32px Arial";
      ctx.fillText(fullName, 40, 255);

      ctx.fillStyle = "#A7F3D0";
      ctx.font = "14px Arial";
      ctx.fillText("N° D'ADHÉRENT", 40, 320);
      ctx.fillStyle = "#ffffff";
      ctx.font = "bold 26px monospace";
      ctx.fillText(number, 40, 352);
      ctx.font = "16px Arial";
      ctx.fillStyle = "#A7F3D0";
      ctx.fillText(type, 40, 390);

      const qrCanvas = qrRef.current?.querySelector("canvas");
      if (qrCanvas) {
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(560, 250, 160, 160);
        ctx.drawImage(qrCanvas, 570, 260, 140, 140);
      }
      return canvas.toDataURL("image/png");
    } catch (e) {
      return null;
    }
  };

  const download = () => {
    const url = buildDataUrl();
    if (!url) return toast.error("Téléchargement impossible.");
    const a = document.createElement("a");
    a.href = url;
    a.download = `carte-membre-${number}.png`;
    a.click();
    toast.success("Carte téléchargée.");
  };

  const send = () => {
    const url = buildDataUrl();
    onSendCard?.(url);
  };

  return (
    <div>
      <div data-testid="member-digital-card" className="bg-gradient-to-br from-brand-blue to-brand-green text-white rounded-lg overflow-hidden shadow-xl">
        <div className="p-7">
          <div className="flex items-center justify-between">
            <img src={LOGO_URL} alt="DEFAR" className="h-11 bg-white/90 p-1 rounded" />
            <span className="text-xs uppercase tracking-widest text-emerald-100">Carte de membre</span>
          </div>
          <div className="mt-10 flex items-end justify-between gap-4">
            <div>
              <p className="text-xs text-emerald-100 uppercase tracking-wide">Membre</p>
              <p className="text-2xl font-bold">{fullName}</p>
              <p className="mt-4 text-xs text-emerald-100 uppercase tracking-wide">N° d'adhérent</p>
              <p className="font-mono text-xl font-semibold" data-testid="member-card-number">{number}</p>
              <p className="mt-2 text-sm text-emerald-100">{type}</p>
            </div>
            <div ref={qrRef} className="bg-white p-2 rounded">
              <QRCodeCanvas value={qrValue} size={96} />
            </div>
          </div>
        </div>
      </div>
      <button
        onClick={download}
        data-testid="download-card-btn"
        className="mt-4 w-full inline-flex items-center justify-center gap-2 border-2 border-brand-blue text-brand-blue hover:bg-brand-blue hover:text-white transition-colors py-3 font-semibold"
      >
        <Download size={18} /> Télécharger ma carte
      </button>
      {onSendCard && (
        <button
          onClick={send}
          disabled={sending}
          data-testid="send-card-btn"
          className="mt-3 w-full inline-flex items-center justify-center gap-2 bg-brand-green text-white hover:bg-brand-greenhover transition-colors py-3 font-semibold disabled:opacity-60"
        >
          <Send size={18} /> {sending ? "Envoi en cours..." : "Envoyer par email au membre"}
        </button>
      )}
    </div>
  );
};
